import { useNavigate } from 'react-router-dom'

/**
 * A custom hook that safely wraps the useNavigate hook from react-router-dom.
 * It provides a fallback function when used outside of a Router context.
 *
 * @returns A function that either navigates using react-router-dom or does nothing.
 */
export function useOptionalNavigate() {
	try {
		// Try to use the real navigate hook
		const navigate = useNavigate()
		return navigate
	} catch (_) {
		// If we're not in a Router context, return a no-op function
		const noopNavigate = (_path: string, _options?: any) => {
			console.warn('Navigation attempted outside of Router context')
			return undefined
		}
		return noopNavigate
	}
}
